import '../App.css';
import React from 'react';
import { auth } from '../firebase';
import { useState } from 'react';
import { signInAnonymously } from "firebase/auth";
import { getUserInfo, logNewUser } from '../logging.js';
import { TextField, Flex, Button, Form, Provider, defaultTheme } from '@adobe/react-spectrum';

function LandingPage({ experiment, workerId, setWorkerId, callbacks }) {
    function manageUserInfo() {
        signInAnonymously(auth)
            .then((credentials) => {
                getUserInfo({ workerId: workerId.toLowerCase() }, callbacks);
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                console.error(errorCode + ": " + errorMessage);
            });
    }

    function submitForm(e) {
        e.preventDefault();
        manageUserInfo();
    }

    function validateId() {

        if (experiment === "exp1-tweaking") {
            return workerId.length > 0 ? true : false;
        }

        else {
            if (workerId.length !== 24) {
                return false;
            }

            else {
                if (/[^a-zA-Z0-9]/.test(workerId)) {
                    return false;
                }
                else {
                    return true;
                }
            }
        }
    }

    return (
        <div>
            <Provider theme={defaultTheme} colorScheme='light'>
                <Flex direction="column" justifyContent={'center'} alignItems={"center"} height={'size-6000'}>
                    <Form width={'size-400'} height={'size-400'} onSubmit={e => submitForm(e)}>
                        <TextField
                            label={experiment === "exp1-tweaking" ? "Please enter your Participant ID" : "Please enter your Prolific ID"}
                            maxLength={24}
                            value={workerId}
                            onChange={setWorkerId} />
                        <Button variant='primary' style='fill' type="submit" isDisabled={!validateId()}>Submit</Button>
                    </Form>
                </Flex>
            </Provider>
        </div>
    )
}

export default LandingPage;